// extracted by mini-css-extract-plugin
module.exports = {"dots-loader":"DotLoader_dots-loader__23rnH","bounce":"DotLoader_bounce__106HM"};